import React  from "react";
import {useParams} from "react-router-dom";

// global components
import {LoadingView} from "../../../../designSystem/components/LoadingView";
import {Typography} from "../../../../designSystem/components/Typography";

// shared components
import {GoBackNavigationIconButton} from "../../../../widgets/GoBackNavigationIconButton";
import {usePostView} from "../../hooks/usePostView";

export const PostViewFeature = () =>  {
  const { postId } = useParams();
  const { post, isLoading } = usePostView({ postId });

  if (isLoading)
    return <LoadingView />;

  return (
    <React.Fragment>
      <div className="px-6 pt-7">
        <div className="self-start">
          <GoBackNavigationIconButton />
        </div>
      </div>
      <div className="px-10 pt-2 pb-4 flex flex-1 flex-col overflow-y-auto max-h-[calc(100vh-100px)]">
        <div className="mt-2 space-y-6 text-[#000000E6] flex-1 ">
          <Typography variant="title" align="center">
            {post?.title}
          </Typography>
          <div dangerouslySetInnerHTML={{ __html: post?.content }} />
        </div>
      </div>
    </React.Fragment>
  );
}